export const REDESIGN_2022 = 'redesign2022';
export const BATTERY_CHECKUP_REDESIGN_2024 = 'batteryCheckupRedesign2024';
export const SIMPLR_AI_2024 = 'simplrAI2024';

export const FEATURE_LIST = [
	REDESIGN_2022,
	BATTERY_CHECKUP_REDESIGN_2024,
	SIMPLR_AI_2024,
];
